import { useFiles } from 'hooks/queries/finder/useFiles'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMemo } from 'react'
import { collectResults } from 'utils/query'

export const useMobileHomeRecentFiles = () => {
  const workspaceId = useCurrentWorkspaceId()
  const recentFilesQuery = useFiles(
    {
      location: 'recents_home_new',
      workspaceId,
      query: { items: 10, load_children_preview_urls: true },
      disableSchema: true,
    },
    { getNextPageParam: undefined },
  )

  const files = useMemo(
    () => collectResults(recentFilesQuery, (data) => data.files.filter((f) => !f.uploads_project)),
    [recentFilesQuery],
  )

  return {
    files,
    isLoading: recentFilesQuery.isLoading,
    isFetched: recentFilesQuery.isFetched,
  }
}
